import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledFindYourMoodBalance = {
  Root: styled.div`
    position: relative;
    z-index: 2;
    padding-top: 40px;
    margin-bottom: 24px;
  `,
  Title: styled.h1`
    font-weight: 700;
    font-size: 27px;
    line-height: 38px;
    margin-bottom: 16px;
    color: ${Color.WHITE};
  `,
  Subtitle: styled.p`
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${Color.WHITE};
    margin-bottom: 24px;
  `,
}
